import React, { useEffect } from 'react';
import { Box, Chip } from '@mui/material'
import { useState } from 'react'
import { DataGridPro, GridActionsCellItem, GridToolbar } from '@mui/x-data-grid-pro';
import LinearProgress from '@mui/material/LinearProgress';
import getDomain from './domain';

//icons
import SendIcon from '@mui/icons-material/Send';
import FourKPlusIcon from '@mui/icons-material/FourKPlus';
import HdIcon from '@mui/icons-material/Hd';
import CircleIcon from '@mui/icons-material/Circle';
import { ContentCopy, Movie } from '@mui/icons-material';
import Player from './player';




export default function ResultsGrid(params) {

    const [rows, setRows] = useState([])
    const search = params?.query
    const selection = params?.selection
    const [loadState, setLoadState] = useState(false)
    const [streamMagnet, setStreamMagnet] = useState('')


    useEffect(() => {
        async function api(query, providers) {
            console.log(`Searching for ${query}`)
            
            setLoadState(true)
            await fetch(`${getDomain()}/tg?query=${query}`)
            .then(async (res) => await res.json())
            .then((json) => setRows(json))

            setLoadState(false)
        }
        if (search && search.trim() !== '') { api(search) }
    }, [search]
    )

    const columns = [
        { field: 'id' },
        { field: 'title', headerName: "Listing Name", flex: 1 },
        {
            field: 'resIcon',
            headerName: "",
            width: 50,
            valueGetter: (r) => r.row.metadata,
            renderCell: (v) => {
                const resolution = parseInt(v.value.resolution) ?? 0
                if (resolution > 2159) { return <FourKPlusIcon  fontSize="large" color='primary'/>}
                if (resolution > 1079) { return <HdIcon fontSize="large" color="secondary" /> }
                else { return "" }
            }

        },
        {
            field: 'seedIcon',
            headerName: "Speed",
            width: 60,
            valueGetter: (r) => parseInt(r.row.seeds),
            renderCell: (v) => {
                if (v.value > 100) { return <CircleIcon color='success' />}
                if (v.value > 30) { return <CircleIcon color='warning'/>}
                if (v.value < 31) { return <CircleIcon  color='error'/>}
                else { return "" }
            }

        },
        { field: 'resolution',
        headerName: "Res",
        type: 'number',
        valueGetter: (r) => parseInt(r.row.metadata.resolution),
        valueFormatter: (v) => `${v.value}p`
    },
        {
            field: 'size',
            headerName: "Size",
            width: 120,
            renderCell: (v) => {
                const sizeGB = (v.value / 1073741824).toFixed(2)
                if (sizeGB > 50) { return <Chip label={sizeGB + " GB"} color='error'/> }
                if (sizeGB > 20) { return <Chip label={sizeGB + " GB"} color='warning'/> }
                if (sizeGB < 20.1) { return <Chip label={sizeGB + " GB"} color='success'/> }
                else { return <Chip label={sizeGB + " GB"} /> }
            }
        },
        { field: 'seeds', headerName: "Seeds", width: 90},
        {
            field: 'actions',
            type: 'actions',
            width: 110,
            getActions: (params) => [
              //<StreamWindow params />,
              <GridActionsCellItem
                icon={<Movie />}
                label="Stream"
                onClick={(event) => setStreamMagnet(params.row.trackerId)}
              />,
              <GridActionsCellItem
                icon={<ContentCopy />}
                label="Copy Magnet"
                onClick={(event) => navigator.clipboard.writeText(params.row.trackerId)}
              />,
              <GridActionsCellItem
                icon={<SendIcon />}
                label="Send to Plex"
                onClick={(event) => sendTorrent(params, selection)}
              />
            ],
          },
    ]

    return (
        <Box>
            {/*c}
            <TvControls sx={{display:tvVisibility}}/>
            {c*/}
            <br></br>
            <DataGridPro 
                columns={columns}
                rows={rows}
                initialState={{
                    columns: {
                        columnVisibilityModel: {
                        // Hide columns status and traderName, the other columns will remain visible
                        id: false,
                        },
                    },
                    sorting: {
                        sortModel: [
                            { id: 1, field: 'resolution', sort: 'desc' },
                            { id: 2, field: 'seeds', sort: 'desc' }
                        ],
                    },
                    }}
                slots={{
                    loadingOverlay: LinearProgress,
                    toolbar: GridToolbar,
                    }}
                loading={loadState}
            />
            <Player magnet={streamMagnet} />
        </Box>
    )
}


async function sendTorrent(params, query) {
    const { trackerId } = params.row

    let category = "movies"
    if (query.name) {category = "tv"}
    console.log(`Category is ${category}`)

    var response = await fetch(`${getDomain()}/add?category=${category}`, {
        method: 'POST',
        headers: {'content-type': 'application/json'},
        body: JSON.stringify({magnet: trackerId, category: category})
    })

    console.log(await response.json())
}